// removed by extract-text-webpack-plugin
module.exports = {"textEllipsis":"_2UrlshiR1he_Q5bBBT2-L4","resetTextMargin":"Fv757qu8R8lWrZ9_ulk3s","dataText":"_3aYZ999E7yg6nEp63usbav","item":"fgAYaAHAKY7fFMoYrl3F2","active":"_7Cxou1yqIprpdEcTTah-v"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/MainPanel/Search/Ticket/Item/style.css
// module id = 2431
// module chunks = 0